import {Component, OnInit} from '@angular/core';
import {PreguntasServices} from '../../services/preguntas.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {PreguntaModel} from '../../models/pregunta.model';
import {SubcategoriaModel} from '../../models/categoria.model';
import {CategoriasServices} from '../../services/categorias.services';
import {ActivatedRoute} from '@angular/router';
import {forkJoin} from 'rxjs';

@Component({
  'selector': 'preguntas-list',
  'templateUrl': '../../templates/admin/preguntas/preguntas.admin.template.html'
})
export class PreguntasAdminComponent implements OnInit {

  listPreguntas: PreguntaModel[] = [];

  rows: any[] = [];

  columns = [
    {name: 'Enunciado'},
    {name: 'peso'},
    {name: 'Subcategoria'},
    {name: 'Acciones'}
  ];

  constructor(private ps: PreguntasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    this.spinner.show();

    this.ps.getAllPreguntas().subscribe((d: any) => {

      this.listPreguntas = d.data.preguntas;


      for (let p of this.listPreguntas) {
        this.rows.push({
          enunciado: p.enunciado,
          id: p._id,
          orden: p.orden,
          peso: p.peso,
          acciones: p._id,
          subcategoria: (p.subcategoria ) ? p.subcategoria.nombre : "Sin categoria"
        });
      }

      this.rows.sort((a: any, b: any) => {
        if (a.subcategoria == b.subcategoria) {
          return a.orden - b.orden;
        } else
          return a.subcategoria - b.subcategoria;
      });




      this.rows = [...this.rows];
      this.spinner.hide();
    });
  }

  borrarPregunta() {

  }
}

@Component({
  'selector': 'preguntas-new',
  'templateUrl': '../../templates/admin/preguntas/preguntas.new.template.html'
})
export class PreguntasNewComponent implements OnInit {

  pregunta: PreguntaModel = new PreguntaModel();

  listSubcat: SubcategoriaModel[] = [];

  constructor(private ps: PreguntasServices, private cs: CategoriasServices, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {

    this.spinner.show();


    this.cs.getAllSubCategorias().subscribe((d: any) => {

      this.listSubcat = d.data.subcategorias;
      this.spinner.hide();
    });
  }

  savePregunta() {
    this.spinner.show();
    this.ps.newPregunta(this.pregunta).subscribe((d: any) => {

      if (d.data.newPregunta == 1)
        alert('Pregunta creada con éxito');
      this.spinner.hide();
    });
  }
}

@Component({
  'selector': 'preguntas-edit',
  'templateUrl': '../../templates/admin/preguntas/preguntas.edit.template.html'
})
export class PreguntasEditComponent implements OnInit {

  pregunta: PreguntaModel;
  idSubcategoria :string;

  listSubcat: SubcategoriaModel[] = [];

  constructor(private ps: PreguntasServices, private spinner: NgxSpinnerService, private cs: CategoriasServices, private activeRouter: ActivatedRoute) {
  }

  ngOnInit(): void {
    let id = this.activeRouter.snapshot.params.id;

    this.spinner.show();

    let consultas: any[] = [];
    consultas.push(this.ps.getPregunta(id));
    consultas.push(this.cs.getAllSubCategorias());

    forkJoin(consultas).subscribe((d: any) => {
      this.pregunta = d[0].data.pregunta;
      this.listSubcat = d[1].data.subcategorias;
      this.idSubcategoria = (this.pregunta.subcategoria ) ? this.pregunta.subcategoria._id : null;
      this.spinner.hide();
    });

  }


  guardarPregunta() {
    this.spinner.show();
    this.pregunta.subcategoria = this.listSubcat.find(s => s._id == this.idSubcategoria);
    this.ps.updatePregunta(this.pregunta).subscribe(d => {
      this.spinner.hide();
    });
  }

}

